<mat-toolbar class="mat-toolbar mat-toolbar-single-row">
  <div class="breadcrumb" [ngClass]="{ 'noback-addmargin': !auth.routeFrom }">
    <div class="crumb">{{ 'EDIT_PROFILE.profile' | translate }}</div>
  </div>
  <div class="spacer"></div>
  <img class="logo logo-h" src="/assets/img/allegion-logo.png" />
  <div class="spacer"></div>
  <div class="menu">
    <button class="menubutton" [matMenuTriggerFor]="userMenu">
      <mat-icon class="account-icon" [style.font-size.px]="32">account_circle</mat-icon>
    </button>
  </div>
</mat-toolbar>
<mat-menu #userMenu="matMenu" [overlapTrigger]="false">
  <button class="logoutbutton" mat-menu-item (click)="auth.logout()">
    <mat-icon iconPositionEnd>power_settings_new</mat-icon>
    <span>{{ 'TOPNAV.sign_out' | translate }}</span>
  </button>
</mat-menu>
